import {
  PORTFOLIOS_LIST,
  PORTFOLIOS_MODIFY,
  PORTFOLIOS_DELETE,
  PORTFOLIOS_CREATE,
  PORTFOLIOS_READ
} from '../const/servicesURI';
import requestService from './requestService';
import { httpRequests } from 'investira.sdk';
import utils from '../utils';

const cancel = {
  list: null
};

export const create = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'post'
  };

  return requestService(xProps, PORTFOLIOS_CREATE, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Portfolios Create');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const list = (pProps, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    params: pProps,
    cancelToken: cancel.list.token
  };

  return requestService(xProps, PORTFOLIOS_LIST, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Portfolios List');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const read = (pCarteiraId, pResolve, pReject, pFinally) => {
  return requestService({}, `${PORTFOLIOS_READ}/${pCarteiraId}`, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Portfolios Read');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const modify = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'patch'
  };

  return requestService(xProps, PORTFOLIOS_MODIFY, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Portfolios Modify');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const remove = (pPortfolioId, pResolve, pReject, pFinally) => {
  const xProps = {
    data: {
      portfolio_id: pPortfolioId
    },
    method: 'delete'
  };

  return requestService(xProps, PORTFOLIOS_DELETE, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Portfolios Remove');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const portfolios = { create, list, read, modify, remove };

export default portfolios;
